import { CountryId, type ICountry } from "@entities/country";
import { DepartureCityId, type DepartureCity } from "@entities/departureCity";

export default function(departureCity?: DepartureCity, country?: ICountry): boolean {
    if(!departureCity || !country) return false;
    return [DepartureCityId.Moscow, DepartureCityId.Peterburg].includes(departureCity.id) && country.id === CountryId.Uae;
}